import { brandAPI } from './api';
import Swal from 'sweetalert2';

export const brandActions = {
    // Fetch all brands with filters
    fetchBrands: (filters = {}) => {
        return async (dispatch) => {
            try {
                const response = await brandAPI.list({
                    page: filters.page || 1,
                    limit: filters.limit || 10,
                    search: filters.search || '',
                    status: filters.status || '',
                    start_date: filters.start_date || '',
                    end_date: filters.end_date || '',
                    sort_by: filters.sort_by || 'created_at',
                    sort_order: filters.sort_order || 'DESC'
                });
                
                if (response.status) {
                    dispatch({
                        type: "Brand_list",
                        payload: response.data
                    });
                    
                    return {
                        success: true,
                        data: response.data,
                        pagination: response.pagination
                    };
                } else {
                    throw new Error(response.message);
                }
            } catch (error) {
                console.error('Error fetching brands:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Failed to fetch brands',
                    confirmButtonColor: '#ff0000'
                });
                return {
                    success: false,
                    message: error.message || 'Failed to fetch brands'
                };
            }
        };
    },
    
    // Get all brands for dropdown (without pagination)
    fetchAllBrands: () => {
        return async () => {
            try {
                const response = await brandAPI.getAll();
                
                if (response.status) {
                    return {
                        success: true,
                        data: response.data
                    };
                } else {
                    throw new Error(response.message);
                }
            } catch (error) {
                console.error('Error fetching all brands:', error);
                return {
                    success: false,
                    message: error.message || 'Failed to fetch brands'
                };
            }
        };
    },
    
    // Get single brand
    fetchBrandById: (id) => {
      debugger;
        return async (dispatch) => {
            try {
                const response = await brandAPI.get(id);
                debugger;
                if (response.status) {
                    dispatch({
                        type: "selectd_brand",
                        payload: response.data
                    });
                    
                    return {
                        success: true,
                        data: response.data
                    };
                } else {
                    throw new Error(response.message);
                }
            } catch (error) {
                console.error('Error fetching brand:', error);
                return {
                    success: false,
                    message: error.message || 'Failed to fetch brand'
                };
            }
        };
    },
    
    // Create brand
    createBrand: (brandData) => {
        return async (dispatch) => {
            try {
                const response = await brandAPI.create(brandData);
                
                if (response.status) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Success!',
                        text: 'Brand created successfully',
                        confirmButtonColor: '#00ff00'
                    });
                    
                    // Refresh brand list
                    dispatch(brandActions.fetchBrands());
                    
                    return {
                        success: true,
                        data: response.data
                    };
                } else {
                    throw new Error(response.message);
                }
            } catch (error) {
                console.error('Error creating brand:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error!',
                    text: error.message || 'Failed to create brand',
                    confirmButtonColor: '#ff0000'
                });
                return {
                    success: false,
                    message: error.message || 'Failed to create brand'
                };
            }
        };
    },
    
    // Update brand
    updateBrand: (id, brandData) => {
        return async (dispatch) => {
            try {
                const response = await brandAPI.update(id, brandData);
                
                if (response.status) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Success!',
                        text: 'Brand updated successfully',
                        confirmButtonColor: '#00ff00'
                    });
                    
                    // Refresh brand list
                    dispatch(brandActions.fetchBrands());
                    
                    return {
                        success: true,
                        data: response.data
                    };
                } else {
                    throw new Error(response.message);
                }
            } catch (error) {
                console.error('Error updating brand:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error!',
                    text: error.message || 'Failed to update brand',
                    confirmButtonColor: '#ff0000'
                });
                return {
                    success: false,
                    message: error.message || 'Failed to update brand'
                };
            }
        };
    },
    
    // Delete brand
    deleteBrand: (id) => {
      debugger;
        return async (dispatch) => {
            try {
                const response = await brandAPI.delete(id);
                
                if (response.status) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Deleted!',
                        text: 'Brand deleted successfully',
                        confirmButtonColor: '#00ff00'
                    });
                    
                    // Refresh brand list
                    dispatch(brandActions.fetchBrands());
                    
                    return {
                        success: true
                    };
                } else {
                    throw new Error(response.message);
                }
            } catch (error) {
                console.error('Error deleting brand:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error!',
                    text: error.message || 'Failed to delete brand',
                    confirmButtonColor: '#ff0000'
                });
                return {
                    success: false,
                    message: error.message || 'Failed to delete brand'
                };
            }
        };
    },
    
    // Search brands
    searchBrands: (searchTerm, filters = {}) => {
        return async (dispatch) => {
            try {
                const response = await brandAPI.search(searchTerm, filters);
                
                if (response.status) {
                    dispatch({
                        type: "brand_list",
                        payload: response.data
                    });
                    
                    return {
                        success: true,
                        data: response.data,
                        pagination: response.pagination
                    };
                } else {
                    throw new Error(response.message);
                }
            } catch (error) {
                console.error('Error searching brands:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Failed to search brands',
                    confirmButtonColor: '#ff0000'
                });
                return {
                    success: false,
                    message: error.message || 'Failed to search brands'
                };
            }
        };
    }
};